export class AdminFormData {
  email: string;
  password: string;
}
